import React from 'react';

import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import {
  Button,
  Drawer,
  Form,
  Select,
  Col,
  Row,
  DatePicker,
  TimePicker,
  Input,
} from 'antd';
import {
  spocLocationDetailsZoho,
  dataUser,
  allLocationWithShortName,
} from './Component/Helpers/util';
import AntDDatePicker from './Component/Common/AntDDateTimePicker/AntDDatePicker';

const Drawer_Form = ({
  showDrawer,
  showDrawer1,
  onClose,
  onClose1,
  drawerType,
  setDrawerType,
  open,
  setOpen,
}) => {
  const [location, setLocation] = React.useState('');
  const [location1, setLocation1] = useState('');
  const [locationIds, setLocationIds] = useState('');
  const [locationId, setLocationId] = useState(null);
  const [locationName, setLocationName] = useState(null); // to get location name
  const [locationData, setLocationData] = React.useState([]);
  const [locationNew, setLocationNew] = React.useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [userid, setUserid] = useState(null);
  const [email, setEmail] = useState(null);
  const userDataLocal = dataUser();
  const UserObj = JSON.parse(userDataLocal);
  const userDataLocal12 = spocLocationDetailsZoho();
  const locationWithShortName = allLocationWithShortName();
  const [form] = Form.useForm(); // Access form instance

  useEffect(() => {
    const LocationSpoc = JSON.parse(userDataLocal12);
    const locationShort = JSON.parse(locationWithShortName);
    setLocationNew(locationShort);
    setLocationData(LocationSpoc);
    setCompanyId(UserObj ? UserObj.company_id : null);
    setUserid(UserObj ? UserObj.rec_id : null);
    setEmail(UserObj ? UserObj.email : null);
  }, []);

  const resetValue = () => {
    form.resetFields();
  };

  const onFinish = values => {
    // For start Date for required format
    let year = values.startDate.$y;
    let month = values.startDate.$M + 1; // Adjusting as $M is 0-based
    let day = values.startDate.$D;

    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    let formattedStartDate = `${year}-${month}-${day}`;

    // To get endDate in required format
    let year2 = values.endDate.$y;
    let month2 = values.endDate.$M + 1; // Adjusting as $M is 0-based
    let day2 = values.endDate.$D;

    month2 = month2 < 10 ? `0${month2}` : month2;
    day2 = day2 < 10 ? `0${day2}` : day2;

    let formattedEndDate = `${year2}-${month2}-${day2}`;
    // For get Location
    const locationValue = values.location;
    const selectedLocation = locationData.find(
      location => location.value === locationValue,
    );
    const locationName = selectedLocation ? selectedLocation.label : '';
    if (drawerType === 'desk-booking') {
      const authToken = JSON.parse(localStorage.getItem('headData'));

      //  to get start Time in required format
      let hours = values.startTime.$H;
      let minutes = values.startTime.$m;
      hours = hours < 10 ? `0${hours}` : hours; // Format hours and minutes as two digits
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      let formattedStartTime = `${hours}:${minutes}`; // Construct the final formatted string

      //  to get end Time in required format
      let hours2 = values.endTime.$H;
      let minutes2 = values.endTime.$m;
      hours2 = hours2 < 10 ? `0${hours2}` : hours2; // Format hours and minutes as two digits
      minutes2 = minutes2 < 10 ? `0${minutes2}` : minutes2;
      let formattedEndTime = `${hours2}:${minutes2}`; // Construct the final formatted string

      const param = {
        product_name: 'Desk Booking',
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        start_time: formattedStartTime,
        end_time: formattedEndTime,
        category: values.category,
        noOfDesk: values.numberOfDesks,
        company_name: UserObj.company_name,
        email: UserObj.email,
        fname: UserObj.fname,
        lname: UserObj.lname,
        phone: UserObj.phone,
        // location_name: JSON.stringify(locationName), // both changed
        location_name: locationName, // both changed
        location_id: values.location,
      };
      axios
        .post(
          `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
          param,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        )
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message, {});
          }
          // setTimeout(() => {
          //     window.location.reload();
          // }, 1000);
          // $('.close').click();
        })
        .catch(err => {
          toast.error('Unable to submit Product enquiry', {});
     
        });
    } else if (drawerType === 'meeting-room') {
      const authToken = JSON.parse(localStorage.getItem('headData'));

      //  to get start Time in required format
      let hours = values.startTime.$H;
      let minutes = values.startTime.$m;
      hours = hours < 10 ? `0${hours}` : hours; // Format hours and minutes as two digits
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      let formattedStartTime = `${hours}:${minutes}`; // Construct the final formatted string

      //  to get end Time in required format
      let hours2 = values.endTime.$H;
      let minutes2 = values.endTime.$m;
      hours2 = hours2 < 10 ? `0${hours2}` : hours2; // Format hours and minutes as two digits
      minutes2 = minutes2 < 10 ? `0${minutes2}` : minutes2;
      let formattedEndTime = `${hours2}:${minutes2}`; // Construct the final formatted string

      const param = {
        product_name: 'Meeting Room',
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        start_time: formattedStartTime,
        end_time: formattedEndTime,
        category: values.category,
        noOfDesk: values.noOfRoom,
        company_name: UserObj.company_name,
        email: UserObj.email,
        fname: UserObj.fname,
        lname: UserObj.lname,
        phone: UserObj.phone,
        location_name: locationName,
        location_id: values.location,
      };
      axios
        .post(
          `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
          param,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        )
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message, {});
          }
          // setTimeout(() => {
          //     window.location.reload();
          // }, 1000);
          // $('.close').click();
        })
        .catch(err => {
          toast.error('Unable to submit Product enquiry', {});
  
        });
      // setBtnStatus(true);
    } else if (drawerType === 'skywatch') {
      const authToken = JSON.parse(localStorage.getItem('headData'));
      const param = {
        product_name: 'SkyWatch',
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        start_time: '',
        end_time: '',
        category: values.numDevices,
        noOfDesk: values.numberOfDesks,
        company_name: UserObj.company_name,
        email: UserObj.email,
        fname: UserObj.fname,
        lname: UserObj.lname,
        phone: UserObj.phone,
        location_name: locationName,
        location_id: values.location,
      };
      axios
        .post(
          `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
          param,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        )
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message, {});
          }
          // setTimeout(() => {
          //     window.location.reload();
          // }, 1000);
          // $('.close').click();
        })
        .catch(err => {
          toast.error('Unable to submit Product enquiry', {});

        });
    } else if (drawerType === 'access-control') {
      const authToken = JSON.parse(localStorage.getItem('headData'));
      const param = {
        product_name: 'Access Control',
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        start_time: '',
        end_time: '',
        noOfDesk: values.numDevices,
        company_name: UserObj.company_name,
        email: UserObj.email,
        fname: UserObj.fname,
        lname: UserObj.lname,
        phone: UserObj.phone,
        location_name: locationName,
        location_id: values.location,
      };

      axios
        .post(
          `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
          param,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        )
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message, {});
          }
          // setTimeout(() => {
          //     window.location.reload();
          // }, 1000);
          // $('.close').click();
        })
        .catch(err => {
          toast.error('Unable to submit Product enquiry', {});
     
        });
    } else if (drawerType === 'attendance') {
      const authToken = JSON.parse(localStorage.getItem('headData'));
      const param = {
        product_name: 'Attendance',
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        noOfDesk: values.numDevices,
        company_name: UserObj.company_name,
        email: UserObj.email,
        fname: UserObj.fname,
        lname: UserObj.lname,
        phone: UserObj.phone,
        location_name: locationName,
        location_id: values.location,
      };

      axios
        .post(
          `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
          param,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        )
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message, {});
          }
          // setTimeout(() => {
          //     window.location.reload();
          // }, 1000);
          // $('.close').click();
        })
        .catch(err => {
          toast.error('Unable to submit Product enquiry', {});

        });
    } else if (drawerType === 'visitor-management') {
      const authToken = JSON.parse(localStorage.getItem('headData'));
      const param = {
        product_name: 'Visitor Management',
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        company_name: UserObj.company_name,
        email: UserObj.email,
        fname: UserObj.fname,
        lname: UserObj.lname,
        phone: UserObj.phone,
        location_name: locationName,
        location_id: values.location,
      };

      axios
        .post(
          `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
          param,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        )
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message, {});
          }
          // setTimeout(() => {
          //     window.location.reload();
          // }, 1000);
          // $('.close').click();
        })
        .catch(err => {
          toast.error('Unable to submit Product enquiry', {});

        });
    }
    form.resetFields();
    onClose();
  };

  return (
    <div>
      {/* <ToastContainer /> */}
      {drawerType === 'desk-booking' ? (
        <Drawer
          title="Desk Booking"
          placement="right"
          onClose={() => {
            onClose();
            form.resetFields();
          }}
          closable={true}
          open={open}
          width={400}
          // Correctly apply marginTop here
          className="AddOnDrawer"
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: 10,
              }}
            >
              {/* <Button onClick={handleReset} style={{ width: '48%' }}> */}
              <Button
                style={{
                  width: '28%',
                  backgroundColor: '#bd2130',
                  color: 'white',
                }}
                onClick={resetValue}
              >
                Reset
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '28%',
                  marginLeft: 10,
                  backgroundColor: '#1e7e34',
                  color: 'white',
                }}
                //    onClick={submitDrawer}
                onClick={() => form.submit()}
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Location Select */}
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select a location' }]}
            >
              <Select
                showSearch
                placeholder="Select Location"
                style={{ width: '100%' }}
                options={locationData}
                // value={location}
                // onChange={changeSelect}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            {/* Row for Start Date and End Date */}
            <Row gutter={16}>
              {/* Start Date */}
              <Col span={12}>
                <Form.Item
                  label="Start Date"
                  name="startDate"
                  rules={[
                    { required: true, message: 'Please select a start date' },
                  ]}
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: '100%' }}
                    // onChange={onDateChange}
                    // value={date}
                  />
                </Form.Item>
              </Col>

              {/* End Date */}
              <Col span={12}>
                <Form.Item
                  label="End Date"
                  name="endDate"
                  rules={[
                    { required: true, message: 'Please select an end date' },
                  ]}
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: '100%' }}
                    // onChange={onDateChange1}
                    // value={date1}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              {/* Start Time */}
              <Col span={12}>
                <Form.Item
                  label="Start Time"
                  name="startTime"
                  rules={[
                    { required: true, message: 'Please select a start time' },
                  ]}
                >
                  <TimePicker
                    style={{ width: '100%' }}
                    format="hh : mm A"
                    // onChange={onStartTimeChange}
                    // value={startTime}
                  />
                </Form.Item>
              </Col>

              {/* End Time */}
              <Col span={12}>
                <Form.Item
                  label="End Time"
                  name="endTime"
                  rules={[
                    { required: true, message: 'Please select an end time' },
                  ]}
                >
                  <TimePicker
                    style={{ width: '100%' }}
                    format="hh : mm A"
                    // onChange={onEndTimeChange}
                    // value={endTime}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              {/* Category */}
              <Col span={12}>
                <Form.Item
                  label="Category"
                  name="category"
                  rules={[
                    { required: true, message: 'Please select a category' },
                  ]}
                >
                  <Input
                    style={{ width: '100%' }}
                    // onChange={categoryChange}
                    // value={category}
                  />
                </Form.Item>
              </Col>

              {/* Number of Tables */}
              <Col span={12}>
                <Form.Item
                  label="No. of Desk"
                  name="numberOfDesks"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the number of desks',
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: 'Please enter a valid number',
                    },
                  ]}
                >
                  <Input
                    style={{ width: '100%' }}
                    // value={noOfDesk}
                    // onChange={noOfDeskChange}

                    type="text"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      ) : drawerType === 'meeting-room' ? (
        <Drawer
          title="Meeting Room"
          placement="right"
          onClose={() => {
            onClose();
            form.resetFields();
          }}
          closable={true}
          open={open}
          width={400}
          // Correctly apply marginTop here
          className="AddOnDrawer"
          headerStyle={{ backgroundColor: '#6f778b', color: 'white' }}
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: 10,
              }}
            >
              {/* <Button onClick={handleReset} style={{ width: '48%' }}> */}
              <Button
                style={{
                  width: '28%',
                  backgroundColor: '#bd2130',
                  color: 'white',
                }}
                onClick={resetValue}
              >
                Reset
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '28%',
                  marginLeft: 10,
                  backgroundColor: '#1e7e34',
                  color: 'white',
                }}
                onClick={() => form.submit()} // Trigger form submission on button click
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Location Select */}
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select a location' }]}
            >
              <Select
                showSearch
                placeholder="Select Location"
                style={{ width: '100%' }}
                options={locationData}
                // value={location}
                // onChange={changeSelect}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            <Form.Item
              label="No. of Meeting Room"
              name="noOfRoom"
              rules={[
                {
                  required: true,
                  message: 'Please enter the number of devices',
                },
              ]}
            >
              <Input type="text" style={{ width: '50%' }} />
            </Form.Item>

            {/* Row for Start Date and End Date */}
<Row gutter={16}>
  {/* Start Date */}
  <Col span={12}>
    <Form.Item
      label="Start Date"
      name="startDate"
      rules={[
        { required: true, message: "Please select a start date" },
      ]}
    >
      <AntDDatePicker
        format="DD/MM/YYYY"
        placeholder="Select start date"
        style={{ width: "100%" }}
        onChange={() => {
          // Reset end date when start date changes
          form.setFieldsValue({ endDate: null });
        }}
      />
    </Form.Item>
  </Col>

  {/* End Date */}
  <Col span={12}>
    <Form.Item
      label="End Date"
      name="endDate"
      dependencies={["startDate"]}
      rules={[
        { required: true, message: "Please select an end date" },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const startDate = getFieldValue("startDate");

            if (!value || !startDate) return Promise.resolve();

            if (value.isBefore(startDate, "day")) {
              return Promise.reject(
                new Error("End date cannot be earlier than start date")
              );
            }

            return Promise.resolve();
          },
        }),
      ]}
    >
      <AntDDatePicker
        format="DD/MM/YYYY"
        placeholder="Select end date"
        style={{ width: "100%" }}
        disabledDate={(current) => {
          const startDate = form.getFieldValue("startDate");
          return (
            startDate &&
            current &&
            current.isBefore(startDate.startOf("day"))
          );
        }}
      />
    </Form.Item>
  </Col>
</Row>

            <Row gutter={16}>
              {/* Start Time */}
              <Col span={12}>
                <Form.Item
                  label="Start Time"
                  name="startTime"
                  rules={[
                    { required: true, message: 'Please select a start time' },
                  ]}
                >
                  <TimePicker style={{ width: '100%' }} format="hh : mm A" />
                </Form.Item>
              </Col>

              {/* End Time */}
              <Col span={12}>
                <Form.Item
                  label="End Time"
                  name="endTime"
                  rules={[
                    { required: true, message: 'Please select an end time' },
                  ]}
                >
                  <TimePicker style={{ width: '100%' }} format="hh : mm A" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      ) : drawerType === 'skywatch' ? (
        <Drawer
          title="SkyWatch"
          placement="right"
          onClose={() => {
            onClose();
            form.resetFields();
          }}
          closable={true}
          open={open}
          width={400}
          // Correctly apply marginTop here
          className="AddOnDrawer"
          headerStyle={{ backgroundColor: '#6f778b', color: 'white' }}
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: 10,
              }}
            >
              {/* <Button onClick={handleReset} style={{ width: '48%' }}> */}
              <Button
                style={{
                  width: '28%',
                  backgroundColor: '#bd2130',
                  color: 'white',
                }}
                onClick={resetValue}
              >
                Reset
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '28%',
                  marginLeft: 10,
                  backgroundColor: '#1e7e34',
                  color: 'white',
                }}
                onClick={() => form.submit()}
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Location Select */}
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select a location' }]}
            >
              <Select
                showSearch
                placeholder="Select Location"
                style={{ width: '100%' }}
                options={locationData}
                // value={location}
                // onChange={changeSelect}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            <Form.Item
              label="Number of Devices"
              name="numDevices"
              rules={[
                {
                  required: true,
                  message: 'Please enter the number of devices',
                },
              ]}
            >
              <Input type="text" style={{ width: '100%' }} />
            </Form.Item>

            {/* Row for Start Date and End Date */}
            <Row gutter={16}>
              {/* Start Date */}
              <Col span={12}>
                <Form.Item
                  label="Start Date"
                  name="startDate"
                  rules={[
                    { required: true, message: 'Please select a start date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>

              {/* End Date */}
              <Col span={12}>
                <Form.Item
                  label="End Date"
                  name="endDate"
                  rules={[
                    { required: true, message: 'Please select an end date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      ) : drawerType === 'access-control' ? (
        <Drawer
          title="Access Control"
          placement="right"
          onClose={() => {
            onClose();
            form.resetFields();
          }}
          closable={true}
          open={open}
          width={400}
          // Correctly apply marginTop here
          className="AddOnDrawer"
          headerStyle={{ backgroundColor: '#6f778b', color: 'white' }}
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: 10,
              }}
            >
              {/* <Button onClick={handleReset} style={{ width: '48%' }}> */}
              <Button
                style={{
                  width: '28%',
                  backgroundColor: '#bd2130',
                  color: 'white',
                }}
                onClick={resetValue}
              >
                Reset
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '28%',
                  marginLeft: 10,
                  backgroundColor: '#1e7e34',
                  color: 'white',
                }}
                onClick={() => form.submit()}
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Location Select */}
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select a location' }]}
            >
              <Select
                showSearch
                placeholder="Select Location"
                style={{ width: '100%' }}
                options={locationData}
                // value={location}
                // onChange={changeSelect}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            {/* Row for Start Date and End Date */}
            <Row gutter={16}>
              {/* Start Date */}
              <Col span={12}>
                <Form.Item
                  label="Start Date"
                  name="startDate"
                  rules={[
                    { required: true, message: 'Please select a start date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>

              {/* End Date */}
              <Col span={12}>
                <Form.Item
                  label="End Date"
                  name="endDate"
                  rules={[
                    { required: true, message: 'Please select an end date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="Number of Each Device"
              name="numDevices"
              rules={[
                {
                  required: true,
                  message: 'Please enter the number of devices',
                },
              ]}
            >
              <Input type="text" style={{ width: '50%' }} />
            </Form.Item>
          </Form>
        </Drawer>
      ) : drawerType === 'attendance' ? (
        <Drawer
          title="Attendance"
          placement="right"
          onClose={() => {
            onClose();
            form.resetFields();
          }}
          closable={true}
          open={open}
          width={400}
          // Correctly apply marginTop here
          className="AddOnDrawer"
          headerStyle={{ backgroundColor: '#6f778b', color: 'white' }}
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: 10,
              }}
            >
              {/* <Button onClick={handleReset} style={{ width: '48%' }}> */}
              <Button
                style={{
                  width: '28%',
                  backgroundColor: '#bd2130',
                  color: 'white',
                }}
                onClick={resetValue}
              >
                Reset
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '28%',
                  marginLeft: 10,
                  backgroundColor: '#1e7e34',
                  color: 'white',
                }}
                onClick={() => form.submit()}
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Location Select */}
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select a location' }]}
            >
              <Select
                showSearch
                placeholder="Select Location"
                style={{ width: '100%' }}
                options={locationData}
                // value={location}
                // onChange={changeSelect}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            {/* Row for Start Date and End Date */}
            <Row gutter={16}>
              {/* Start Date */}
              <Col span={12}>
                <Form.Item
                  label="Start Date"
                  name="startDate"
                  rules={[
                    { required: true, message: 'Please select a start date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>

              {/* End Date */}
              <Col span={12}>
                <Form.Item
                  label="End Date"
                  name="endDate"
                  rules={[
                    { required: true, message: 'Please select an end date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="Number of Devices"
              name="numDevices"
              rules={[
                {
                  required: true,
                  message: 'Please enter the number of devices',
                },
              ]}
            >
              <Input type="text" style={{ width: '50%' }} />
            </Form.Item>
          </Form>
        </Drawer>
      ) : drawerType === 'visitor-management' ? (
        <Drawer
          title="Visitor Management"
          placement="right"
          onClose={() => {
            onClose();
            form.resetFields();
          }}
          closable={true}
          open={open}
          width={400}
          // Correctly apply marginTop here
          className="AddOnDrawer"
          headerStyle={{ backgroundColor: '#6f778b', color: 'white' }}
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: 10,
              }}
            >
              {/* <Button onClick={handleReset} style={{ width: '48%' }}> */}
              <Button
                style={{
                  width: '28%',
                  backgroundColor: '#bd2130',
                  color: 'white',
                }}
                onClick={resetValue}
              >
                Reset
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '28%',
                  marginLeft: 10,
                  backgroundColor: '#1e7e34',
                  color: 'white',
                }}
                // onClick={() => form.submit()}
                onClick={() => {
                  form.submit();
                }}
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Location Select */}
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select a location' }]}
            >
              <Select
                showSearch
                placeholder="Select Location"
                style={{ width: '100%' }}
                options={locationData}
                // value={location}
                // onChange={changeSelect}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            {/* Row for Start Date and End Date */}
            <Row gutter={16}>
              {/* Start Date */}
              <Col span={12}>
                <Form.Item
                  label="Start Date"
                  name="startDate"
                  rules={[
                    { required: true, message: 'Please select a start date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>

              {/* End Date */}
              <Col span={12}>
                <Form.Item
                  label="End Date"
                  name="endDate"
                  rules={[
                    { required: true, message: 'Please select an end date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      ) : (
        ''
      )}
    </div>
  );
};

export default Drawer_Form;
